/*
 * Configurazione centralizzata di Google reCAPTCHA v3.
 *
 * La site key NON va scritta nei componenti: viene letta da
 * process.env.VUE_APP_RECAPTCHA, valorizzata in vue.config.js
 * (un valore per ogni ambiente, come per VUE_APP_WEB_PATH).
 *
 * Se la variabile non e' valorizzata reCAPTCHA viene disattivato:
 * lo script non viene caricato e getRecaptchaToken() restituisce null,
 * cosi' il tool continua a funzionare in locale senza chiavi.
 */

export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA || '';

export const RECAPTCHA_ACTIONS = {
  // Invio del form "Invia stima" (Forms/InviaStima)
  SEND_QUOTATION: 'relax_send_quotation',
  // Invio del form "Attiva offerta" (Forms/AttivaOfferta)
  ACTIVATION_OFFER: 'relax_activation_offer',
  // Invio del form "Hai bisogno di aiuto?" (Forms/Help)
  SEND_HELP: 'relax_send_help',
};

const SCRIPT_ID = 'recaptcha-v3';

let loadPromise = null;

/*
 * Carica una sola volta lo script https://www.google.com/recaptcha/api.js
 * e risolve quando grecaptcha e' pronto. Va invocata all'avvio dell'app
 * cosi' reCAPTCHA puo' osservare il comportamento dell'utente durante
 * tutta la compilazione degli step e assegnare uno score piu' attendibile.
 */
export function loadRecaptcha() {
  if (!RECAPTCHA_SITE_KEY) return Promise.resolve(false);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    if (document.getElementById(SCRIPT_ID)) return resolve(true);

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + RECAPTCHA_SITE_KEY;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error('Impossibile caricare lo script di reCAPTCHA'));
    document.head.appendChild(script);
  });

  return loadPromise;
}

/*
 * Restituisce il token da inviare al backend insieme ai dati del form.
 * In caso di errore (script bloccato, chiave errata, rete assente)
 * restituisce null: sara' il backend a decidere se accettare la richiesta,
 * ed e' compito del chiamante mostrare l'eventuale errore all'utente.
 */
export async function getRecaptchaToken(action) {
  if (!RECAPTCHA_SITE_KEY) return null;

  try {
    await loadRecaptcha();
  } catch (error) {
    console.log('recaptcha', error);
    return null;
  }

  if (typeof window.grecaptcha === 'undefined') return null;

  return new Promise(resolve => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, {action: action})
        .then(token => resolve(token))
        .catch(error => {
          console.log('recaptcha', error);
          resolve(null);
        });
    });
  });
}
